import { render, staticRenderFns } from "./EmailChip.vue?vue&type=template&id=642ac55a&"
import script from "./EmailChip.vue?vue&type=script&lang=ts&"
export * from "./EmailChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports